import React from 'react';
import glamorous from 'glamorous';

const SubFieldFilename = () => {
  return (
    <div>
      <h4>Subfield [alt_text]</h4>
      <p>
        Alternative text for the image (in case the image cannot be displayed)
      </p>
      <p>
        <strong>MANDATORY</strong>
      </p>
      <br/>
      <glamorous.Div>
        <strong>Best practice:</strong>
        <ul className="pl-list">
          <li>
            Ensure that the alternative text is descriptive and meaningful as it will be used when either an image
            cannot be displayed or when the website is accessed through a screen reader for a user with a visual or
            other cognitive disability.
          </li>
        </ul>
      </glamorous.Div>
      <br/>
      <div>
        Example:
      </div>
      <pre>
        <code className="language-xml">
          {`<recall lang="en" xmlns="urn:recall-schema">
  <image>
    <filename>Dolphin1.jpg</filename>
    <media_type>image/jpeg</media_type>
    <alt_text>3 wheel stroller with black powder-coated steel frame and a fabric seat, basket and hood</alt_text>
    ...
  </image>
  <image>
    <filename>Dolphin2.jpg</filename>
    <media_type>image/jpeg</media_type>
    <alt_text>3 wheel stroller with black powder-coated steel frame and a fabric seat, basket and hood</alt_text>
    ...
  </image>
  ...
</recall>
`}
        </code>
      </pre>
    </div>
  );
};

export default SubFieldFilename;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/complex-field-images/subfield-alt-text.js